import React from 'react';
import {
  Box,
  Flex,
  Button,
  Stack,
  Container,
  Heading,
} from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const bgColor = 'white';
  const borderColor = 'primary.100';
  const location = useLocation();
  const testRoute = {
    pathname: '/test',
    search: location.search,
  };

  return (
    <Box 
      as="header"
      bg={bgColor}
      borderBottom={1}
      borderStyle={'solid'}
      borderColor={borderColor}
      px={4}
      boxShadow={'sm'}
      borderTop={'4px solid'}
      borderTopColor={'accent.500'}
    >
      <Container maxW="container.xl">
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <Heading as={RouterLink} to="/" size="md" color="primary.500">
            Aididactic · Perfil de aprendizaje
          </Heading>

          <Flex alignItems={'center'}>
            <Stack direction={'row'} spacing={4}>
              <Button
                as={RouterLink}
                to="/"
                fontSize={'sm'}
                fontWeight={500}
                variant={'ghost'}
                colorScheme={'blue'}
              >
                Inicio
              </Button>
              
              <Button
                as={RouterLink}
                to={testRoute}
                fontSize={'sm'}
                fontWeight={600}
                variant={'solid'}
                colorScheme={'blue'}
              >
                Hacer el cuestionario
              </Button>
            </Stack>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Header;
